var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._g({attrs:{"type":"text","id":_vm.id,"size":_vm.getSize,"autocomplete":"off"},on:{"keydown":function($event){return _vm.checkPattern($event)},"blur":function($event){return _vm.checkFormat()}},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-402ead4d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BlumarDecimalInput.vue
// module id = 893
// module chunks = 0